/**
 * Icônes nav / recherche chargées en synchrone pour éviter un flash au premier rendu (header).
 */
import type { ComponentProps, ComponentType } from "react";
import SvgIconPrimitive from "../SvgIcon/SvgIcon";
import ArrowheadDownIcon from "./ArrowheadDownIcon";
import CartIcon from "./CartIcon";
import CaretDown16Icon from "./CaretDown16Icon";
import MenuIcon from "./MenuIcon";
import PinIcon from "./PinIcon";
import SearchIcon from "./SearchIcon";
import StoreIcon from "./StoreIcon";
import UserIcon from "./UserIcon";

export const syncSvgIconComponents: Record<
  string,
  ComponentType<ComponentProps<typeof SvgIconPrimitive>>
> = {
  MenuIcon,
  CartIcon,
  UserIcon,
  SearchIcon,
  // CLS-FIX: header StoreMenu + delivery status (SSR avait svg-icon-pending)
  StoreIcon,
  PinIcon,
  CaretDown16Icon,
  // CLS-FIX: menu catégorie SSR — pending 16px puis Accordion 24px
  ArrowheadDownIcon,
};
